import React from 'react';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormWidget from '../../common/form/FormWidget';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { LocationField } from '../attributes';
import { AllowedLocationTypesEnum } from './locationHelper';

type LocationAttributeEditorProps = {
    field: LocationField;
};

export default function LocationAttributeEditor({ field }: LocationAttributeEditorProps) {
    const allowedTypes = Array.isArray(field?.allowedLocationTypes)
        ? field.allowedLocationTypes
        : field?.allowedLocationTypes
          ? [field.allowedLocationTypes]
          : [];
    const hasCountry = allowedTypes.includes(AllowedLocationTypesEnum.country);

    return (
        <FormContainer>
            <FormItem>
                <FormWidget
                    name={field.name}
                    component={FORM_WIDGET_COMPONENTS.location}
                    label={field.label}
                    multiple={field.isMultiSelect}
                    restrictToCountry={hasCountry}
                />
            </FormItem>
        </FormContainer>
    );
}
